package com.devi3east.bashbuddy.leaderboard.navigation

import androidx.navigation.NavGraphBuilder
import androidx.navigation.compose.composable
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen
import com.devi3east.bashbuddy.leaderboard.ui.LeaderboardScreenRoute

fun NavGraphBuilder.leaderboardNavGraph(
    appState: AppState
) {
    composable(Screen.LeaderboardScreen.route) {
        LeaderboardScreenRoute(
            appState = appState
        )
    }
}